import React from 'react';
import { MessageSquareIcon, StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  return <section className="py-16 bg-gray-50" data-id="element-360">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-361">
        <div className="text-center mb-12" data-id="element-362">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl" data-id="element-363">
            Lo que otros están diciendo
          </h2>
          <p className="mt-4 text-lg text-gray-600" data-id="element-364">
            Personas reales que ya están aplicando las técnicas
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-365">
          <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-366">
            <div className="flex items-center mb-4" data-id="element-367">
              <div className="bg-green-100 rounded-full p-2 mr-3" data-id="element-368">
                <MessageSquareIcon className="h-5 w-5 text-green-600" data-id="element-369" />
              </div>
              <div data-id="element-370">
                <h3 className="font-medium text-gray-900" data-id="element-371">Laura, 34 años</h3>
                <p className="text-sm text-gray-500" data-id="element-372">Madrid</p>
              </div>
            </div>
            <div className="flex mb-4" data-id="element-373">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-5 w-5 text-yellow-400" data-id="element-374" />)}
            </div>
            <p className="text-gray-600 text-sm" data-id="element-375">
              "En solo dos semanas sentí que mi mente estaba más tranquila. Las
              técnicas de respiración son increíblemente efectivas cuando siento
              que la ansiedad aumenta."
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-376">
            <div className="flex items-center mb-4" data-id="element-377">
              <div className="bg-green-100 rounded-full p-2 mr-3" data-id="element-378">
                <MessageSquareIcon className="h-5 w-5 text-green-600" data-id="element-379" />
              </div>
              <div data-id="element-380">
                <h3 className="font-medium text-gray-900" data-id="element-381">Carlos, 42 años</h3>
                <p className="text-sm text-gray-500" data-id="element-382">Buenos Aires</p>
              </div>
            </div>
            <div className="flex mb-4" data-id="element-383">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-5 w-5 text-yellow-400" data-id="element-384" />)}
            </div>
            <p className="text-gray-600 text-sm" data-id="element-385">
              "Siempre me costó desconectar del trabajo. Este kit me dio
              herramientas prácticas para calmarme en momentos de alta presión.
              Ahora duermo mejor y estoy más presente con mi familia."
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-386">
            <div className="flex items-center mb-4" data-id="element-387">
              <div className="bg-green-100 rounded-full p-2 mr-3" data-id="element-388">
                <MessageSquareIcon className="h-5 w-5 text-green-600" data-id="element-389" />
              </div>
              <div data-id="element-390">
                <h3 className="font-medium text-gray-900" data-id="element-391">Marta, 29 años</h3>
                <p className="text-sm text-gray-500" data-id="element-392">México</p>
              </div>
            </div>
            <div className="flex mb-4" data-id="element-393">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-5 w-5 text-yellow-400" data-id="element-394" />)}
            </div>
            <p className="text-gray-600 text-sm" data-id="element-395">
              "El Método 5-4-3-2-1 cambió mi vida. Lo uso cada vez que siento
              que mi mente empieza a acelerarse con preocupaciones. En cuestión
              de minutos, recupero el control."
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-396">
            <div className="flex items-center mb-4" data-id="element-397">
              <div className="bg-green-100 rounded-full p-2 mr-3" data-id="element-398">
                <MessageSquareIcon className="h-5 w-5 text-green-600" data-id="element-399" />
              </div>
              <div data-id="element-400">
                <h3 className="font-medium text-gray-900" data-id="element-401">Javier, 38 años</h3>
                <p className="text-sm text-gray-500" data-id="element-402">Colombia</p>
              </div>
            </div>
            <div className="flex mb-4" data-id="element-403">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-5 w-5 text-yellow-400" data-id="element-404" />)}
            </div>
            <p className="text-gray-600 text-sm" data-id="element-405">
              "Probé muchas soluciones para mi ansiedad, pero nada tan práctico
              como este kit. Los bonos son excelentes, especialmente la playlist
              y las afirmaciones. Lo recomiendo completamente."
            </p>
          </div>
        </div>
      </div>
    </section>;
}